import { z } from "zod";

export const create = z.object({
  name: z.string().min(1, "Required"),
  type: z.enum([
    "TEXT",
    "TEXTAREA",
    "NUMBER",
    "BOOLEAN",
    "DATE",
    "DATETIME",
    "SELECT",
    "MULTI_SELECT",
  ]),
  allowFreeText: z.boolean().prefault(false),
  options: z
    .array(z.object({ id: z.number(), value: z.string().min(1, "Required") }))
    .optional(),
});

export const update = create.extend({
  id: z.number(),
});
